<template>
  <div class="home-first">
    <!--<h2 class="light-font">中国经济大数据可视化系列报告</h2>-->
    <img src="../../assets/img/title.png" alt="title" class="title">
    <div class="item-index item-num">
      <img src="@/assets/img/home_index.png" alt="指标" class="icon-img">
      <!--<span class="light-font name">指标</span>-->
      <img src="../../assets/img/home_index_text.png" alt="指标" class="name"/>
      <span class="black-font number">{{ showIndexNum }}+</span>
    </div>
    <div class="item-report item-num">
      <img src="@/assets/img/home_report.png" alt="报告" class="icon-img">
      <!--<span class="light-font name">报告</span>-->
      <img src="../../assets/img/home_report_text.png" alt="报告" class="name"/>
      <span class="black-font number">{{ showReportNum }}+</span>
    </div>
    <div class="item-industry item-num">
      <img src="@/assets/img/home_industry.png" alt="行业" class="icon-img">
      <!--<span class="light-font name">行业</span>-->
      <img src="../../assets/img/home_industry_text.png" alt="行业" class="name"/>
      <span class="black-font number">{{ showIndustryNum }}+</span>
    </div>
  </div>
</template>

<script>
import { TweenLite } from 'gsap';
import { $dg_getReportAmount } from '../../api';

export default {
  name: 'HomeFirst',
  data() {
    return {
      indexNum: 0,
      reportNum: 0,
      industryNum: 0,
    };
  },
  computed: {
    showIndexNum() {
      return this.indexNum;
    },
    showReportNum() {
      return this.reportNum.toFixed(0);
    },
    showIndustryNum() {
      return this.industryNum.toFixed(0);
    },
  },
  methods: {
    async getReportAmount() {
      let reportNum = await $dg_getReportAmount();
      if (!reportNum) reportNum = 0;
      TweenLite.to(this, 1, { indexNum: '200,000' });
      TweenLite.to(this, 1, { reportNum });
      TweenLite.to(this, 1, { industryNum: 20 });
    },
  },
  async mounted() {
    this.getReportAmount();
  },
};
</script>

<style scoped lang="scss">
.home-first{
  .title{
    margin-bottom: 16vh;
    /*font-size: 48px;*/
    /*font-family: 'SourceHanSansCN-Blod';*/
  }
  .item-num {
    margin-bottom: 50px;
    /*img{*/
      /*width: 80px;*/
      /*height: 80px;*/
      /*margin-bottom: 30px;*/
    /*}*/
    .name{
      /*font-size: 34px;*/
      /*font-family: 'a-black-Blod';*/
      margin-top: 4px;
    }
    .icon-img{
      width: 67px;
      height: 65px;
    }
    .number{
      font-size: 38px;
      line-height: 1;
      font-family: 'a-black-Blod';
      color: #69D1F8;
      margin-left: 45px;
      margin-top: 7px;
      display: inline-block;
    }
  }
}
</style>
